import React from "react";
import Skeleton from "./Skeleton";
import ProjectCardsSkeleton from "./ProjectCardsSkeleton";
import skeletonStyles from "../../style/skeleton.module.css";

const PROJECT_COUNT = 12;

const ProjectsPageSkeleton = () => (
  <div
    className="container page-shell pt-3 pt-md-5 pb-4 skeleton-page"
    aria-busy="true"
    aria-live="polite"
    aria-label="Loading projects"
  >
    <Skeleton className={skeletonStyles.skeletonTitle} />
    <div className={`${skeletonStyles.skeletonStack} mb-4 mt-2`}>
      <Skeleton
        className={`${skeletonStyles.skeletonParagraph} ${skeletonStyles.skeletonParagraphShort}`}
      />
    </div>

    <ProjectCardsSkeleton
      count={PROJECT_COUNT}
      variant="showcase"
      gridClassName="m-0 p-0"
    />
  </div>
);

export default ProjectsPageSkeleton;
